import {Box, Paper, Typography} from "@mui/material";

export default function AlarmsReportPage(){
    return(
        <Paper elevation={3}>
            <Box p={2} style={{height: 600}}>
                <Typography variant="h5" component="h1">Alarms Report Page</Typography>
            </Box>
        </Paper>
    );
}
